import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {query} from "lit/decorators/query.js";
import {SbkButton} from "@/components/button/button.ts";

// eslint-disable-next-line
declare let _paq: any

@customElement('sbk-eht-enrollment-declaration-link')
export class SbkEhtEnrollmentDeclarationLink extends LitElement {

    @query('sbk-button')
    _button?: SbkButton

    connectedCallback() {
        super.connectedCallback();
        this._button && this._button.addEventListener('click', () => {
            const lang = window.location.href.indexOf('/en') > -1 ? 'englisch' : 'deutsch'
            _paq.push(['trackEvent', 'Absprung Beitrittserklaerung', `Beitrittserklaerung ${lang}`])
        });
    }

    protected createRenderRoot() {
        return this
    }
}
